/* Marie Bags: menu-lade (open/sluiten via Dawn's header-drawer, uitklapbare onderlijst). Geen afhankelijkheden. */
(function () {
  function init() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var details = drawer.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    details.addEventListener('toggle', function () {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
    function toggleSub(btn) {
      var target = document.getElementById(btn.getAttribute('aria-controls'));
      if (!target) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      target.classList.toggle('is-open', open);
    }
    drawer.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-mb-close]');
      if (closer) {
        e.preventDefault();
        summary.click();
        return;
      }
      var tog = e.target.closest('[data-mb-toggle]');
      if (tog) {
        e.preventDefault();
        toggleSub(tog);
      }
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest('[data-mb-close],[data-mb-toggle]');
      if (!el) return;
      e.preventDefault();
      el.click();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
